// extracted by mini-css-extract-plugin
export default {"button":"ButtonDefault_button__vd6ba"};